import objectPath from 'object-path'

const getRuleLoadingTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const setRuleLoadingUiChanged = (designContext = {}, target) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext

  objectPath.set(isUiChanged, target, { isRender: true })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)
}

const setRuleLoadingAction = (
  designContext = {},
  action = {},
  isLoading,
  target = '',
) => {
  let { elementAction = {}, setElementAction } = designContext
  let targetKey = getRuleLoadingTarget(action, target)
  if (!targetKey) return undefined

  objectPath.set(elementAction, ['isLoading', targetKey], isLoading)
  setRuleLoadingUiChanged(designContext, targetKey)
  if (setElementAction) setElementAction(elementAction)

  return {
    key: targetKey,
    isLoading,
  }
}

export const onRuleLoading = (
  designContext = {},
  action = {},
  target = '',
) => {
  return setRuleLoadingAction(designContext, action, true, target)
}

export const onRuleDoneLoading = (
  designContext = {},
  action = {},
  target = '',
) => {
  return setRuleLoadingAction(designContext, action, false, target)
}
